import React from 'react';

import { WithDimensionsProps } from 'app/shared/components/styleUtils';
import { WithSpacingProps } from 'app/shared/components/styleUtils';
import { Box } from 'app/shared/components/atoms';
import { Grid, GridItem } from 'app/shared/components/atoms';

interface EventTagsProps extends WithSpacingProps, WithDimensionsProps {
  backgroundComponent: React.ReactNode;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const EventTags: React.FC<React.PropsWithChildren<EventTagsProps>> = ({
  w,
  h,
  backgroundComponent,
  pt = 6,
  pr = 4,
  pb = 4,
  pl = 4,
  onClick,
  children,
}) => {
  const tagPaddingProps = { pt, pr, pb, pl };
  const numberOfColumns = 6;

  const gridItemProps = {
    mobile: numberOfColumns,
    tablet: numberOfColumns,
    smallDesktop: numberOfColumns,
    largeDesktop: numberOfColumns,
    row: 1,
    mobileStart: 1,
    tabletStart: 1,
    smallDesktopStart: 1,
    largeDesktopStart: 1,
  };

  return (
    <Box w={w} h={h} onClick={onClick} data-qaid="event-tags">
      <Grid gap={4} numberOfColumns={numberOfColumns}>
        <GridItem {...gridItemProps}>{backgroundComponent}</GridItem>
        <GridItem
          gap={2}
          flexWrap="wrap"
          alignContent="flex-start"
          {...gridItemProps}
          {...tagPaddingProps}
        >
          <>{children}</>
        </GridItem>
      </Grid>
    </Box>
  );
};
